import { Array2D } from "@lib/titan2/dist/util/collection/Array2D";
import { PatternCell } from "./PatternCell";
/*
 * Pattern.ts
 */
export class Pattern {
    constructor(rows, columns, cells) {
        this.rows = rows;
        this.columns = columns;
        this.cells = cells ? cells : this.createCells();
        this.createKey();
    }
    createCells() {
        let cells = new Array2D(this.rows, this.columns);
        for (let row = 0; row < this.rows; row++) {
            for (let column = 0; column < this.columns; column++) {
                cells.setValue(row, column, new PatternCell(PatternCell.INACTIVE));
            }
        }
        return cells;
    }
    createKey() {
        this.key = "";
        for (let row = 0; row < this.rows; row++) {
            for (let column = 0; column < this.columns; column++) {
                let cell = this.getCell(row, column);
                this.key += cell.getValue();
            }
        }
    }
    getCell(row, column) {
        return this.cells.getValue(row, column);
    }
    setCell(row, column, value) {
        let cell = this.getCell(row, column);
        cell.setValue(value);
    }
    combine(value) {
        for (let row = 0; row < this.rows; row++) {
            for (let column = 0; column < this.columns; column++) {
                let cell = value.getCell(row, column);
                if (cell.isActive()) {
                    this.setCell(row, column, cell.getValue());
                }
            }
        }
    }
    rotate() {
        let rotatedCells = new Array2D(this.rows, this.columns);
        for (let row = 0; row < this.rows; ++row) {
            for (let column = 0; column < this.columns; ++column) {
                let cell = this.getCell(this.rows - column - 1, row);
                rotatedCells.setValue(row, column, cell);
            }
        }
        return new Pattern(this.rows, this.columns, rotatedCells);
    }
    getKey() {
        return this.key;
    }
    equals(patternSet) {
        let key = patternSet.getKey();
        return key == this.getKey();
    }
    getCells() {
        return this.cells;
    }
    getRows() {
        return this.rows;
    }
    getColumns() {
        return this.columns;
    }
}
//# sourceMappingURL=Pattern.js.map